import { ReactNode } from 'react';

import { IconCheckDefault } from '@iwoca/icons';
import classNames from 'classnames';

type TFundingProgressStepProps = {
    status: 'pending' | 'active' | 'complete';
    label: string;
    message: ReactNode;
};

export const FundingProgressStep = ({
    label,
    status,
    message
}: TFundingProgressStepProps) => {
    return (
        <div
            data-testid={`funding-progress-step-${status}`}
            aria-label={`Step: ${label}`}
            className={classNames('grow basis-0', {
                'min-sm:basis-s': label === 'Provide documents'
            })}
        >
            <div
                className={classNames('h-xs w-full rounded-full', {
                    'bg-primary-10': status === 'active',
                    'bg-secondary-40': status === 'complete',
                    'bg-secondary-90': status === 'pending'
                })}
            />
            <div
                className={classNames(
                    'flex items-center justify-center gap-xs pt-m text-xs',
                    status === 'active'
                        ? 'text-primary-10'
                        : 'text-secondary-40'
                )}
            >
                {status === 'complete' && (
                    <IconCheckDefault className="-ml-xs shrink-0" />
                )}
                <span
                    className={classNames('text-center min-sm:text-left', {
                        'hidden min-sm:inline': status === 'complete'
                    })}
                >
                    {message}
                </span>
            </div>
        </div>
    );
};
